import React from "react";

import "./Box.scss";

export type BoxProps = {
  cx?: string;
  type?: "normal";
};

export const Box: React.FC<BoxProps> = ({
  cx = "",
  type = "normal",
  children,
}) => {
  return <div className={`Box ${type} ${cx}`}>{children}</div>;
};
